<template>
    <div class="col-md-3 col-sm-6 news" v-if="item">
        <div>
            <router-link :to="newsPath(item)">
                <img class="featured-img img-fluid pb-3" v-lazy="image">
            </router-link>
        </div>
        <div>
            <h4><router-link :to="newsPath(item)">{{item.title}}</router-link></h4>
            <p v-html="item.short"></p>
            <router-link :to="newsPath(item)"><span aria-hidden="true">&raquo;</span> {{ $t('button.ReadMore') }}</router-link>
        </div>
    </div>
</template>

<script>
  import newsMixin from '../../mixins/newsMixin';
  import {replacePathImageForSmall} from "../../utils/images";

  export default {
    name: 'FeaturedNewsItem',
    props: ['item'],
    mixins: [newsMixin],
    computed: {
       image() {
         return replacePathImageForSmall(this.item.image);
       }
    }
  };
</script>

<style scoped>

</style>
